import React from "react";
import lookupService from "../../services/LookupService";
import { AxiosResponse } from "axios";
import DataGrid, {
    Pager,
    Paging,
    FilterRow,
    Column,
    Sorting,
    Editing,
    Lookup,
    PatternRule,
    SearchPanel,
    StateStoring,
    Export,
} from "devextreme-react/data-grid";
import { LoadIndicator, LoadPanel } from "devextreme-react";
import CookieService, { DXGridCookieKeyTypes } from "../../services/CookieService";
import {
    OnRowUpdatingEvent,
    OnRowInsertingEvent,
    OnRowRemovingEvent,
    onEditCanceledEvent,
} from "../../types/DevExtremeTypes";
import { onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
interface ServiceTypeGridProps {
    // define props if needed
}

interface ServiceTypeGridState {
    // example state structure
    data: any[];
    loadPanelVisible: boolean;
    showProgressIndicator: boolean;
    errorMessage: any[];
    active: boolean;
}
type Service = {
    id: string;
    value: string;
    subTypeOptions: SubType[];
};

type SubType = {
    id: string;
    value: string;
    typeOptions: TypeOption[];
    displayName: string | null;
};

type TypeOption = {
    id: string;
    value: string;
    displayName: string | null;
};

type Flattened = {
    serviceId: string;
    service: string;
    subTypeId: string;
    subType: string;
    typeId: string | null;
    type: string | null;
    subTypeDisplayName: string | null;
    typeDisplayName: string | null;
};

export default class ServiceTypeGrid extends React.Component<ServiceTypeGridProps, ServiceTypeGridState> {
    LookupService: lookupService;
    constructor(props: ServiceTypeGridProps) {
        super(props);
        this.state = {
            data: [],
            loadPanelVisible: false,
            showProgressIndicator: false,
            errorMessage: [],
            active: true,
        };

        // bind functions if not written as arrow functions
        this.loadData = this.loadData.bind(this);
        this.LookupService = new lookupService();
    }

    componentDidMount() {
        this.loadData();
    }
    flattenServices(data: Service[]) {
        const result: Flattened[] = [];

        data.forEach((service) => {
            service.subTypeOptions.forEach((sub) => {
                if (sub.typeOptions && sub.typeOptions.length > 0) {
                    sub.typeOptions.forEach((type) => {
                        result.push({
                            serviceId: service.id,
                            service: service.value,
                            subTypeId: sub.id,
                            subType: sub.value,
                            typeId: type.id,
                            type: type.value,
                            subTypeDisplayName: sub.displayName,
                            typeDisplayName: type.displayName,
                        });
                    });
                } else {
                    result.push({
                        serviceId: service.id,
                        service: service.value,
                        subTypeId: sub.id,
                        subType: sub.value,
                        typeId: null,
                        type: null,
                        subTypeDisplayName: sub.displayName,
                        typeDisplayName: null,
                    });
                }
            });
        });
        this.setState({
            data: result,
        });
    }
    loadData() {
        this.setState({
            showProgressIndicator: true,
        });
        this.LookupService.getServiceHierarchy().then(this.handleSuccess).catch(this.handleError);
    }
    handleSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            showProgressIndicator: false,
            loadPanelVisible: false,
        });
        this.flattenServices(response.data.data.serviceOptions);
    };

    handleError = (error: AxiosResponse<any>) => {
        this.setState({
            showProgressIndicator: false,
            loadPanelVisible: false,
        });
        //var respMessage: string = "Rate service failed with response: " + JSON.stringify(error);
    };
    onCustomGridLoad() {
        return CookieService.loadDXGridConfiguration(DXGridCookieKeyTypes.rateMatrixGrid);
    }

    onCustomGridSave(gridState: Object) {
        CookieService.saveDXGridConfiguration(DXGridCookieKeyTypes.rateMatrixGrid, gridState);
    }

    onRowUpadating = async (e: any) => {
        const updated = e.newData;
        const original = e.oldData;

        const hasSubTypeChange =
            updated.subTypeDisplayName !== undefined && updated.subTypeDisplayName !== original.subTypeDisplayName;

        const hasTypeChange =
            updated.typeDisplayName !== undefined && updated.typeDisplayName !== original.typeDisplayName;

        try {
            this.setState({ loadPanelVisible: true });

            const apiCalls: Promise<any>[] = [];

            if (hasSubTypeChange) {
                apiCalls.push(
                    this.LookupService.updateSubTypeDisplayName({
                        id: Number(original.subTypeId),
                        displayName: updated.subTypeDisplayName,
                        value: original.subType,
                    })
                );
            }

            if (hasTypeChange) {
                apiCalls.push(
                    this.LookupService.updateTypeDisplayName({
                        id: Number(original.typeId),
                        displayName: updated.typeDisplayName,
                        value: original.type,
                    })
                );
            }
            if (apiCalls.length > 0) {
                await Promise.all(apiCalls);
            }
            await this.loadData();
        } catch (err) {
            console.error(err);
            e.cancel = true;
            this.setState({ errorMessage: ["Update failed"] });
        } finally {
            this.setState({ loadPanelVisible: false });
        }
    };

    onEditCancelled = (e: onEditCanceledEvent) => {
        this.setState({
            errorMessage: [],
        });
    };
    onRowEditting = () => {
        this.setState({
            active: false,
        });
    };
    onEditorPreparing = (editEvent: any) => {
        if (editEvent.parentType === "dataRow") {
            const editableFields = ["subTypeDisplayName", "typeDisplayName"];

            if (!editableFields.includes(editEvent.dataField)) {
                editEvent.editorOptions.readOnly = true;
                editEvent.editorOptions.disabled = true;
            }
        }
    };
    renderErrorMessage = (errorMessage: any[]) => {
        let errorData: React.ReactNode = <></>;
        if (errorMessage) {
            errorData = (
                <span className="unscheduled-shift">
                    <ul>
                        {errorMessage.map((item: any, uniqueKey: number) => {
                            return (
                                <li key={uniqueKey}>
                                    {item.columnName}: {item.errorMessage}
                                </li>
                            );
                        })}
                    </ul>
                </span>
            );
        }
        return errorData;
    };
    render() {
        var { errorMessage, loadPanelVisible } = this.state;
        return (
            <div>
                {this.renderErrorMessage(errorMessage)}
                {this.state.showProgressIndicator ? (
                    <div className="starter-template">
                        <LoadIndicator
                            id="simple-grid-indicator"
                            height={100}
                            width={100}
                            visible={this.state.showProgressIndicator}
                        />
                    </div>
                ) : (
                    <>
                        {/* <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={loadPanelVisible} /> */}
                        <DataGrid
                            dataSource={this.state.data}
                            showBorders={false}
                            showColumnLines={false}
                            hoverStateEnabled={true}
                            columnAutoWidth={true}
                            allowColumnReordering={true}
                            onRowUpdating={this.onRowUpadating}
                            onEditCanceling={this.onEditCancelled}
                            onEditingStart={this.onRowEditting}
                            onEditorPreparing={this.onEditorPreparing}
                            allowColumnResizing={true}
                            columnResizingMode={"widget"}
                        >
                            <SearchPanel visible={true} placeholder={"Search"} />
                            <Sorting mode="single" />
                            <Paging defaultPageSize={10} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                            <Editing mode="row" useIcons={true} allowUpdating={true} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={this.onCustomGridLoad}
                                customSave={this.onCustomGridSave}
                                savingTimeout={0}
                            />
                            <Column type="buttons" buttons={["edit"]} />

                            <Column dataField="serviceId" caption="SERVICE ID" allowEditing={false} />
                            <Column dataField="service" caption="SERVICE NAME" allowEditing={false} />

                            <Column dataField="subTypeId" caption="SUBTYPE ID" allowEditing={false} />
                            <Column dataField="subType" caption="SUBTYPE NAME" allowEditing={false} />

                            {/* ONLY THIS SHOULD BE EDITABLE */}
                            <Column dataField="subTypeDisplayName" caption="SUBTYPE DISPLAY NAME" allowEditing={true} />

                            <Column dataField="typeId" caption="TYPE ID" allowEditing={false} />
                            <Column dataField="type" caption="TYPE NAME" allowEditing={false} />

                            {/* ONLY THIS SHOULD BE EDITABLE */}
                            <Column dataField="typeDisplayName" caption="TYPE DISPLAY NAME" allowEditing={true} />
                        </DataGrid>
                    </>
                )}
            </div>
        );
    }
}
